import { colors, fontSize, size } from "@styles/theme"
import styled from "@emotion/styled/macro"

import { Slider as MuiSlider } from "@base-ui/react"
import { PiSpinnerBold } from "react-icons/pi"

const SliderControl = styled(MuiSlider.Control)`
  display: flex;
  align-items: center;
  width: 100%;
  padding-block: ${size(1.5)};
  touch-action: none;
  user-select: none;
  padding-left: ${size(1)};
  padding-right: ${size(1)};
`

const SliderTrack = styled(MuiSlider.Track)`
  width: 100%;
  height: 0.25rem;
  background-color: #333333;
  box-shadow: inset 0 0 0 1px #333333;
  border-radius: 0.25rem;
  user-select: none;
`

const SliderIndicator = styled(MuiSlider.Indicator)`
  border-radius: 0.25rem;
  background-color: rgba(255,255,255,0.5);
  user-select: none;
`

const SliderThumb = styled(MuiSlider.Thumb)`
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  background-color: ${colors.statusColors.right_now('primary')};
  user-select: none;

  &:has(:focus-visible) {
    outline: 2px solid blue;
  }
`

const SpinnerContainer = styled.div`
  position: absolute;
  top: ${size(1)};
  right: ${size(2)};

  display: flex;
  align-items: center;
  
  font-size: ${fontSize('sm')};
  color: grey;
`

const SliderValue = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const Slider = ({ isDisabled, isDisplayedInactive, showSpinner, renderSliderValue=(() => {}), slotProps={ control: {}, track: {}, indicator: {}, thumbs: {} }, ...rest }) => {
  return (
    <MuiSlider.Root
      style={{ position: 'relative', width: '100%' }}
      disabled={isDisabled}
      {...rest}>
      {showSpinner &&
        <SpinnerContainer>
          <PiSpinnerBold
            size={size(2)}
            className='animation_rotation'
          />
          &nbsp;loading
        </SpinnerContainer>
      }
      <MuiSlider.Value>
        {(props) => (
          <SliderValue style={{ color: isDisplayedInactive && 'grey' }}>
            {renderSliderValue(props)}
          </SliderValue>
        )}
      </MuiSlider.Value>
      <SliderControl {...(slotProps?.control ?? {})}>
        <SliderTrack {...(slotProps?.track ?? {})}>
          <SliderIndicator {...(slotProps?.indicator ?? {})} />
          <SliderThumb
            style={{ backgroundColor: isDisplayedInactive && 'grey' }}
            {...(slotProps?.thumbs ?? {})}
          />
          <SliderThumb
            style={{ backgroundColor: isDisplayedInactive && 'grey' }}
            {...(slotProps?.thumbs ?? {})}
          />
        </SliderTrack>
      </SliderControl>
    </MuiSlider.Root>
  )
}

export { Slider }
